import React from 'react';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import Plus from '@wix/da-ds/pkg/Icons/16x16/Add';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Check from '@wix/da-ds/pkg/Icons/16x16/Check';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { useWatchButton } from '../../WatchButton/useWatchButton';

import s from './AuthorWatchButton.scss';

export interface Props {
  author: PapiUser;
  className?: string;
  watchingClassname?: string;
  iconClassName?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  isWatchingBack?: boolean;
  ghostButton?: boolean;
  isSummary?: boolean;
  onWatch?: () => void;
  onToggleWatchSuccess?: (isWatchingBack?: boolean) => void;
}

export const AuthorWatchButton: React.FC<Props> = ({
  author,
  className,
  children,
  onWatch,
  iconClassName,
  isWatchingBack,
  ghostButton,
  watchingClassname,
  isSummary,
  disabled,
  onToggleWatchSuccess,
}) => {
  const { onClick, text, isWatching, biData } = useWatchButton(
    author,
    author?.isWatching,
    isWatchingBack,
    disabled,
    onToggleWatchSuccess
  );

  const buttonContent = (
    <>
      <Plus
        disableDefaultColors
        className={classnames(s['plus-icon'], iconClassName)}
        size={IconSize.SMALLER}
      />
      <Close
        disableDefaultColors
        className={classnames(s['close-icon'], iconClassName)}
        size={IconSize.SMALLER}
      />
      {isWatching && (
        <>
          <Check
            disableDefaultColors
            className={classnames(s['check-icon'], iconClassName)}
            size={IconSize.SMALLER}
          />
        </>
      )}
      {children || text}
    </>
  );
  const onClickHandler = e => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
    onWatch && onWatch();
  };

  if (ghostButton) {
    return (
      <GhostButton
        size={isSummary ? 'medium' : 'small'}
        variant={'main'}
        biData={biData}
        className={classnames(
          s['root-ghost'],
          isWatching && s['watching'],
          isWatching && watchingClassname,
          className
        )}
        onClick={onClickHandler}
        disabled={disabled || (isSummary && isWatching)}
      >
        {buttonContent}
      </GhostButton>
    );
  }

  return (
    <TextButton
      variant="approval-green"
      size="small"
      biData={biData}
      className={classnames(
        s['root'],
        isWatching && s['watching'],
        isWatching && watchingClassname,
        className
      )}
      onClick={onClickHandler}
      disabled={disabled}
    >
      {buttonContent}
    </TextButton>
  );
};
AuthorWatchButton.displayName = 'AuthorWatchButton';

export default AuthorWatchButton;
